import { render, staticRenderFns } from "./editManagement.vue?vue&type=template&id=527a8bee&scoped=true&"
import script from "./editManagement.vue?vue&type=script&lang=js&"
export * from "./editManagement.vue?vue&type=script&lang=js&"
import style0 from "./editManagement.vue?vue&type=style&index=0&id=527a8bee&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527a8bee",
  null
  
)

export default component.exports